import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "..";

interface AuthState {
    isAuthenticated: boolean;
}

const initialState: AuthState = {
    isAuthenticated: false,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuth: (state, action) => {
            return action.payload
        }
    },
});

export const { setAuth } = authSlice.actions;
export const selectCount = (state: RootState) => state.auth;

export default authSlice.reducer;
